import { render, staticRenderFns } from "./ShopSidebar.vue?vue&type=template&id=67bbfe12&scoped=true&"
import script from "./ShopSidebar.vue?vue&type=script&lang=js&"
export * from "./ShopSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShopSidebar.vue?vue&type=style&index=0&id=67bbfe12&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bbfe12",
  null
  
)

export default component.exports